import React, { useState} from 'react';
import styled from 'styled-components';
import IMTContractEdit from './imtContractEdit';
import RSBAMasterlistAdd from './rsbaMasterlistAdd';
import ChevronDownIcon from '../Assets/icons/chevron.svg';
import {  ChevronWrapper,  EditLabel } from './StyledComponents';
import useimtContract from '../Hooks/IMTcontractHooks/useImtContract';
import adminBg from '../Assets/bg/adminbg.jpg';
import Loader from '../Components/Loader';

const RsbaMasterlist = ({ setShowimtContract, isSidebarExpanded, darkMode }) => {
  const [selectedItem, setSelectedItem] = useState(null);
  const [showEditPanel, setShowEditPanel] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const { data, loading, error } = useimtContract();


  const handleEditData = (item) => {
    setSelectedItem(item);
    setShowEditPanel(true);
  };

  const closeEditPanel = () => {
    setShowEditPanel(false);
    setSelectedItem(null);
  };

  const filteredData = data.filter(item =>
    (item.iaName?.toLowerCase() || '').includes(searchQuery.toLowerCase()) ||
    (item.municipality?.toLowerCase() || '').includes(searchQuery.toLowerCase()) ||
    (item.iaPresident?.toLowerCase() || '').includes(searchQuery.toLowerCase())
  );
  
  if (loading) {
        return (
          <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh',
            backgroundColor: darkMode ? 'black' : 'white',
          }}>
            <Loader />
          </div>
        );
      }   

  if (error) {
    return <div>Error: {error.message}</div>; 
  }

  return (
    <SlidingPanel darkMode={darkMode}show={true} isSidebarExpanded={isSidebarExpanded}>
    <Container darkMode={darkMode} isSidebarExpanded={isSidebarExpanded}>
    <Header darkMode={darkMode}>
    <Heading darkMode={darkMode}>RSBA MASTERLIST</Heading>
        </Header>

        <SearchContainer>
        <SearchInput
          type="text"
          placeholder="Search Last Name..."
          value={searchQuery}
           onChange={(e) => setSearchQuery(e.target.value)}
        />
        </SearchContainer>

        <TableWrapper>
        <Table darkMode={darkMode}>
            <thead>

            <tr>
              <TableHeaderS  colSpan="5" darkMode={darkMode}></TableHeaderS>
            
              <TableHeaderS darkMode={darkMode}colSpan="3" style={{ textAlign: 'center' }}>ADDRESS OF IA</TableHeaderS>
              <TableHeaderS darkMode={darkMode}colSpan="9" style={{ textAlign: 'center' }}>FULL NAME</TableHeaderS>
             <TableHeaderS darkMode={darkMode}colSpan="4" style={{ textAlign: 'center' }}>RESIDENCE</TableHeaderS>
              <TableHeaderS darkMode={darkMode}colSpan="5" style={{ textAlign: 'center' }}>FARM LOCATION</TableHeaderS>

           </tr>
              <tr>

                <TableHeader  darkMode={darkMode}>NO.</TableHeader>     
                <TableHeader  darkMode={darkMode}>NAME  OF SYSTEM</TableHeader>
                <TableHeader  darkMode={darkMode}>TYPE OF SYSTEM</TableHeader>
                <TableHeader  darkMode={darkMode}>NAME OF IA</TableHeader>
                <TableHeader  darkMode={darkMode}>PROVINCE</TableHeader>
                <TableHeader  darkMode={darkMode}>MUNICIPALITY</TableHeader>
                <TableHeader  darkMode={darkMode}>BARANGAY</TableHeader>
                <TableHeader  darkMode={darkMode}>LAST NAME</TableHeader>
                <TableHeader  darkMode={darkMode}>FIRST NAME</TableHeader>
                <TableHeader  darkMode={darkMode}>MIDDLE NAME</TableHeader>
                <TableHeader  darkMode={darkMode}>EXTENSION NAME</TableHeader>
                <TableHeader  darkMode={darkMode}>SEX (M/F)</TableHeader>
                <TableHeader  darkMode={darkMode}>BIRTHDAY (MM-DD-YYYY)</TableHeader>
                <TableHeader  darkMode={darkMode}>MOTHER'S MAIDEN NAME</TableHeader>
                <TableHeader  darkMode={darkMode}>PROVINCE</TableHeader>
                <TableHeader  darkMode={darkMode}>MUNICIPALITY/CITY</TableHeader>
                <TableHeader  darkMode={darkMode}>BARANGAY</TableHeader>
                <TableHeader  darkMode={darkMode}>PROVINCE</TableHeader>
                <TableHeader  darkMode={darkMode}>HOUSE NUMBER/ STREET/ PUROK</TableHeader>
                <TableHeader  darkMode={darkMode}>PROVINCE</TableHeader>
                <TableHeader  darkMode={darkMode}>MUNICIPALITY</TableHeader>
                <TableHeader  darkMode={darkMode}>BARANGAY</TableHeader>
                <TableHeader  darkMode={darkMode}>FARM LOT NO.</TableHeader>
                <TableHeader  darkMode={darkMode}>FARM AREA (Ha)</TableHeader>
                <TableHeader  darkMode={darkMode}>TYPE OF OWNERSHIP</TableHeader>
                <TableHeader  darkMode={darkMode}>RSBSA REGISTERED? (Y/N)</TableHeader>

                <TableHeader  darkMode={darkMode}>WITH DA IMC? (Y/N)</TableHeader>
                <TableHeader  darkMode={darkMode}>IF YES, RSBSA REFERENCE NO.? (00-00-00-000-000000)</TableHeader>
                <TableHeader  darkMode={darkMode}>IF NONE, RSBSA STUB CONTROL NUMBER? (00-00-00-000-000000)
                or type LOST, if RSBSA Enrollment Stub was lost</TableHeader>
                <TableHeader  darkMode={darkMode}>WITH NATIONAL ID? (Y/N) (Y/N)</TableHeader>
                <TableHeader  darkMode={darkMode}>IF YES, PHILSYS CARD NUMBER?
                0000-0000-0000-0000</TableHeader>
                <TableHeader  darkMode={darkMode}>IF NONE, TRANSACTION SLIP NO.
                or type LOST, if Transaction Slip was lost</TableHeader>
                <TableHeader  darkMode={darkMode} className="station-canal">By signing this, I hereby give consent to the collection of my data for the purposes of the programs of the Department of Agriculture and attest that all information is true and correct
                (Signature over printed name)</TableHeader>

              </tr>

              
            </thead>
            <tbody>
            {filteredData.map((item, index) => (
                <TableRow key={item.id} darkMode={darkMode}>
                  <TableData darkMode={darkMode}>
                  {index + 1}
                    <ChevronWrapper>
             <StyledChevronIcon src={ChevronDownIcon} alt="Chevron" />
             <EditLabel onClick={() => handleEditData(item)}> Edit</EditLabel>
            </ChevronWrapper>
                  </TableData>
                  {/* <TableData darkMode={darkMode}>{item.region}</TableData>
                  <TableData darkMode={darkMode}className="station-imo">{item.imo}</TableData>
                  <TableData darkMode={darkMode}>{item.province}</TableData>
                  <TableData darkMode={darkMode}>{item.projectName}</TableData>
                  <TableData darkMode={darkMode}>{item.moaSigned}</TableData>
                  <TableData darkMode={darkMode}>{item.constructionStarted}</TableData>
                  <TableData darkMode={darkMode}>{item.projectCompleted}</TableData>
                  <TableData darkMode={darkMode}>{item.turnOver}</TableData>
                  <TableData darkMode={darkMode}>{item.pcr_submitted}</TableData>
                  <TableData darkMode={darkMode}>{item.manualSubmitted}</TableData>
                  <TableData darkMode={darkMode}>{item.imt_contractSigned}</TableData>
                  <TableData darkMode={darkMode}>{item.contractArea}</TableData>  
                  <TableData darkMode={darkMode}className="station-canal">{item.canalType}</TableData>
                  <TableData darkMode={darkMode} className="station-column">
                            {item.station}
                  </TableData>

                  <TableData darkMode={darkMode}>{item.lined}</TableData>
                  <TableData darkMode={darkMode}>{item.unlined}</TableData>
                  <TableData darkMode={darkMode}>{item.pipes}</TableData>
                  <TableData darkMode={darkMode}className="station-canal">{item.canalType}</TableData>
                  <TableData darkMode={darkMode}className="station-canal">{item.canalType}</TableData>
                  <TableData darkMode={darkMode}className="station-canal">{item.canalType}</TableData>
                  <TableData darkMode={darkMode}className="station-canal">{item.canalType}</TableData>
                  <TableData darkMode={darkMode}className="station-canal">{item.canalType}</TableData>
                  <TableData darkMode={darkMode}className="station-canal">{item.canalType}</TableData>
                  <TableData darkMode={darkMode}className="station-canal">{item.canalType}</TableData>
                  <TableData darkMode={darkMode}className="station-canal">{item.canalType}</TableData>
                  <TableData darkMode={darkMode} className="station-column">
                            {item.station}
                  </TableData>
                  <TableData darkMode={darkMode} className="station-column">
                            {item.station}
                  </TableData>
                  <TableData darkMode={darkMode} className="station-column">
                            {item.station}
                  </TableData>
                  <TableData darkMode={darkMode} className="station-column">
                            {item.station}
                  </TableData>
                  <TableData darkMode={darkMode} className="station-column">
                            {item.station}
                  </TableData>
                  <TableData darkMode={darkMode} className="station-column">
                            {item.station}
                  </TableData>
                  <TableData darkMode={darkMode} className="station-column">
                            {item.station}
                  </TableData> */}
                  
                </TableRow>
              ))}
            </tbody>
          </Table>
        </TableWrapper>

        {showEditPanel && <IMTContractEdit selectedItem={selectedItem} closeEditPanel={closeEditPanel} />}
      </Container>

      <RightPanel  darkMode={darkMode} >
      <RSBAMasterlistAdd darkMode={darkMode}/>
      </RightPanel>
    </SlidingPanel>
  );
};

export default RsbaMasterlist;

const Container = styled.div`
  background-color: ${({ darkMode }) => (darkMode ? 'transparent' : '#f2f2f2')};
  background-image: ${({ darkMode }) => (darkMode ? `url(${adminBg})` : 'none')};
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  color: ${({ darkMode }) => (darkMode ? ' #757272' : '#333')};
  display: 'flex',
  padding: 10px;
  width: ${({ isSidebarExpanded }) => (isSidebarExpanded ? 'calc(100% - 110px)' : '55%')};
  min-height: 100vh;
  overflow-y: auto;
  margin-left: ${({ isSidebarExpanded }) => (isSidebarExpanded ? '110px' : '10px')};
  margin-top: 30px;
  box-shadow: -4px 0 10px rgba(0, 0, 0, 0.2);
  transition: margin-left 0.3s ease, width 0.3s ease;
`;

const SlidingPanel = styled.div`
  position: fixed;
  top: 0px;
  right: ${({ isSidebarExpanded }) => (isSidebarExpanded ? '0%' : '0')};
  width: 97%;
  height: 100%;
  background-color: ${({ darkMode }) => (darkMode ? 'transparent' : '#ccc')};
  background-image: ${({ darkMode }) => (darkMode ? `url(${adminBg})` : 'none')};
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  box-shadow: -4px 0 10px rgba(0, 0, 0, 0.2);
  transform: translateX(100%);
  transition: transform 0.5s ease, right 0.3s ease-in-out, width 0.3s ease-in-out;
  z-index: 2;
  padding: 20px;
  box-sizing: border-box;

  ${({ show }) => show && `transform: translateX(0);`}
`;

const Header = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-left: 0px;
  margin-bottom: 5px;
  margin-top: 5px;
`;

const Heading = styled.h2`
  font-size: 20px;
 color: ${({ darkMode }) => (darkMode ? '#fff' : '#333')};
  font-weight: bold;
  text-transform: uppercase;
  font-family: 'Poppins', sans-serif;
  margin-bottom: 0px;
`;


const StyledChevronIcon = styled.img`
  margin-top: -25px;  
  margin-left: 5px;  
   width: 14px; 
  height: 14px;   // Add margin to the left
`;


const TableWrapper = styled.div`
  width: 100%;
 height: 500px;
 overflow: auto; 
 margin-top: 10px;
  position: relative;
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  min-width: 1500px;
  background-color: ${({ darkMode }) => (darkMode ?  'rgb(42, 48, 42)' : '#fff')};
  color: ${({ darkMode }) => (darkMode ? '#fff' : '#333')};
  
`;

const TableHeaderS = styled.th`
  background-color: ${({ darkMode }) => (darkMode ? 'rgb(36, 110, 45)' : '#f2f2f2')};
  padding: 0 12px;
  top: 3px;
  position: sticky;
  z-index: 1;
  text-align: center;
  border-left: 1px solid #ddd; /* Keep left border */
  border-right: 1px solid #ddd; /* Keep right border */
  border-top: 1px solid #ddd; 
  border-bottom: 4px solid #ddd;
  font-size: 12px;
  color: ${({ darkMode }) => (darkMode ? '#fff' : '#333')};

   &:first-child {
    position: sticky;
    left: 0;
    z-index: 3; /* Ensure it's above the other headers */
    background-color: ${({ darkMode }) => (darkMode ? 'rgb(25, 88, 32)' : '#f2f2f2')}; /* Ensure it matches the background */
  }

   &[colspan="2"] {
    text-align: center;
    font-weight: bold;
  }
`;

const TableHeader = styled.th`
  background-color: ${({ darkMode }) => (darkMode ? '#f2f2f2' : 'rgb(37, 112, 46)')};
  padding: 0 10px;
  height: 10px;
  top: 0px;
  position: sticky;
  z-index: 2;
  text-align: center;  /* Center text horizontally */
  vertical-align: middle; 
  border-left: 1px solid #ddd; /* Keep left border */
  border-right: 1px solid #ddd; /* Keep right border */
  border-top: 1px solid #ddd; /* Keep top border */
  border-bottom: none;
  font-size: 12px;
  color: ${({ darkMode }) => (darkMode ? '#333' : '#fff')};
  margin-top: 10px;

   &:first-child {
    position: sticky;
    left: 0;
    z-index: 3; /* Ensure it's above the other headers */
    background-color: ${({ darkMode }) => (darkMode ? '#f2f2f2' : 'rgb(37, 112, 46)')}; 
  }

   &[colspan="2"] {
    text-align: center;
    font-weight: bold;
  }

  &.station-canal {
    min-width: 150px;
    max-width: 400px;
    height: 100px;

    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

const TableData = styled.td`
  padding: 5 5px;
  font-size: 12px;
  text-align: center;
  border: 1px solid #ddd;
  color: ${({ darkMode }) => (darkMode ? '#f2f2f2' : '#333')};
 
  transition: background-color 0.3s ease, color 0.3s ease;

  &:first-child {
    position: sticky;
    left: 0;
    background-color: ${({ darkMode }) => (darkMode ? 'rgb(37, 112, 46)2' : '#f2f2f2')}; 
    
   };
    z-index: 1;
  }
 
   &.station-column {
    min-width: 180px;
    max-width: 250px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &.station-imo {
    min-width: 150px;
    max-width: 250px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

   &.station-canal {
    min-width: 150px;
    max-width: 250px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

const TableRow = styled.tr`
 background-color: ${({ darkMode }) => (darkMode ? 'rgb(13, 99, 17)' : '#f9f9f9')};

   &:hover {
    background-color: ${({ darkMode }) => (darkMode ? 'rgb(37, 112, 46)' : 'rgb(37, 112, 46)')};
    background-size: cover;
    color: ${({ darkMode }) => (darkMode ? '#f2f2f2' : '#fff')}; // Ensure the text color changes too
    z-index: 10;  // Ensure it overlaps correctly during hover (if needed)
  }

  /* Hover effect on cells inside the row */
  &:hover td {
    background-image: ${({ darkMode }) => (darkMode ? `url(${adminBg})` : 'none')};
    background-size: cover;
    color: ${({ darkMode }) => (darkMode ? '#fff' : '#fff')};  // Text color change on hover
  }
`;

const RightPanel = styled.div`
  position: fixed;
  padding-top: 10px;
  margin-top: 14px;
  top: 0;
  right: 0;
  width: 43%;
  height: 1%;
  background-color: ${({ darkMode }) => (darkMode ? 'transparent' : '#fff')};
  background-image: ${({ darkMode }) => (darkMode ? `url(${adminBg})` : 'none')};
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  box-shadow: -4px 0 10px rgba(0, 0, 0, 0.2);
  z-index: ${({ showEditPanel }) => (showEditPanel ? 1 : 0)};
  padding: 9px;
  box-sizing: border-box;

  ${({ show }) => show && `transform: translateX(0);`}
`;

const SearchContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-bottom: 10px;
  margin-top: 0px;
`;

const SearchInput = styled.input`
  padding: 8px;
  font-size: 14px;
  width: 250px;
  border: 1px solid #f2f2f2;
  border-radius: 5px;
`;